'use client';

import React from 'react';

import Box from '@mui/material/Box';
import { useLocale } from 'next-intl';
import styled from 'styled-components';

import ProductPageContentBlock from './components/ProductPageContentBlock';
import { addTypeAndParentSlugToTopics } from './utils';
import ForumWidget from '@/ui/components/ForumWidget';

export const Headline = styled.div`
  padding-bottom: 40px;
  padding-top: 20px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding-top: 1rem;
    padding-bottom: 2rem;
  }
`;

type ManualData = {
  data: CategoryData;
  slug: string;
  title: string;
};

interface ProductLink {
  buttonLabel?: string;
  description: string;
  meta?: {
    type: {
      value: string;
      label: string;
    };
    release_date: string;
    files: {
      platform: string;
      show_linux_info: boolean;
      file_url: string;
      file_size: string;
    }[];
    release_log_url?: string;
  };
  slug: string;
  title: string;
  type: string;
}

type ContentBlock = {
  id: string;
  title: string;
  order: number;
  items: Record<string, string>[];
};

interface ProductProps {
  links: ProductLink[] | Product[];
  forumItems: object | null;
  mainArticles: ArticleData[];
  manuals: Record<string, ManualData>;
  product: Product;
  topics: CategoryData[];
  troubleshootingArticles: ArticleData[];
  productPageContentBlocks: ContentBlock[];
}

const Product: React.FC<ProductProps> = ({
  forumItems,
  // mainArticles,
  manuals,
  product,
  topics,
  // troubleshootingArticles,
  productPageContentBlocks,
}) => {
  const locale = useLocale();

  addTypeAndParentSlugToTopics(topics, product.slug);

  if (!product) return null;

  return (
    <>
      {productPageContentBlocks &&
        productPageContentBlocks.map(block => (
          <Box key={block.title} style={{ order: 1 }}>
            <ProductPageContentBlock data={block} manuals={manuals} />
          </Box>
        ))}

      {forumItems && (
        <Box mt={6} style={{ order: 3 }}>
          <ForumWidget
            locale={locale}
            serverData={forumItems}
            headerStyle={false}
          />
        </Box>
      )}
    </>
  );
};

export default Product;
